<div class="ml-comparison-container">
  <!-- Left Section: Chart (60%) -->
  <div class="chart-section">
    <div *ngIf="!data" class="no-data-message">Loading chart data...</div>
    <div *ngIf="data && chartOptions" class="chart-container">
      <highcharts-chart 
        [options]="chartOptions" 
        class="comparison-highchart">
      </highcharts-chart>
    </div>
  </div>

  <!-- Right Section: Metric Cards (40%) -->
  <div class="metrics-section">
    <div class="metric-card improvement-card">
      <div class="card-label">Improvement</div>
      <div class="card-value" [ngClass]="improvementClass">
        <span class="improvement-icon">{{ improvementIcon }}</span>
        {{ improvementValue }}%
      </div>
    </div>

    <div class="metric-card sku-locations-card">
      <div class="card-label">Total SKU-Locations</div>
      <div class="card-value">{{ totalSkuLocations }}</div>
    </div>
  </div>
</div>
